import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import { extractReturnTo } from '../auth/returnTo';

export default function AuthCallback() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="text-slate-600">Signing you in…</div>
      </div>
    );
  }

  if (auth.error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50 p-4">
        <div className="max-w-md text-center">
          <h2 className="text-lg font-semibold text-red-600 mb-2">Sign-in failed</h2>
          <p className="text-sm text-slate-600 mb-4">{auth.error.message}</p>
          <button
            onClick={() => auth.signinRedirect()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Try again
          </button>
        </div>
      </div>
    );
  }

  return <Navigate to={extractReturnTo(auth.user)} replace />;
}
